// Comprehensive chatbot response system
const responses = {
  greetings: {
    keywords: ['hi', 'hello', 'hey', 'greetings', 'good morning', 'good afternoon', 'good evening'],
    response: "Hello! 👋 Welcome to Wisdom Consultancy. How can I help you with your financial planning today? I can assist with investments, insurance, retirement planning, or use our calculators."
  },
  sip: {
    keywords: ['sip', 'systematic investment', 'monthly investment', 'sip calculator'],
    response: "📈 SIP (Systematic Investment Plan) allows you to invest a fixed amount regularly in mutual funds. Benefits:\n• Rupee cost averaging\n• Power of compounding\n• Start with as low as ₹500\n• Flexible investment amount\n\nWant to try our SIP Calculator? Visit our Calculators page!"
  },
  lumpsum: {
    keywords: ['lumpsum', 'lump sum', 'one time investment', 'bulk investment'],
    response: "💰 Lumpsum investment means investing a large amount at once. It's ideal when you have surplus funds. Use our Lumpsum Calculator to see how your investment can grow over time!"
  },
  swp: {
    keywords: ['swp', 'systematic withdrawal', 'regular income', 'monthly income'],
    response: "💵 SWP (Systematic Withdrawal Plan) allows you to withdraw a fixed amount regularly from your investments. Perfect for retirement income or regular cash flow needs."
  },
  retirement: {
    keywords: ['retirement', 'pension', 'retire', 'old age', 'retirement planning'],
    response: "👴 Retirement Planning is crucial for financial independence. We help you:\n• Calculate retirement corpus needed\n• Create investment strategy\n• Choose right pension plans\n• Ensure inflation-adjusted returns\n\nUse our Retirement Calculator to get started!"
  },
  insurance: {
    keywords: ['insurance', 'health insurance', 'life insurance', 'term insurance', 'medical', 'policy'],
    response: "🛡️ We offer comprehensive insurance solutions:\n• Health Insurance - Family floater, critical illness\n• Life Insurance - Term plans, whole life\n• Vehicle Insurance - Car, bike\n• Property Insurance\n\nContact us for the best plans tailored to your needs!"
  },
  mutualFund: {
    keywords: ['mutual fund', 'mf', 'equity', 'debt', 'hybrid', 'large cap', 'mid cap', 'small cap'],
    response: "📊 Mutual Funds are professionally managed investment vehicles. Types:\n• Equity Funds - High growth potential\n• Debt Funds - Stable returns\n• Hybrid Funds - Balanced approach\n• ELSS - Tax saving\n\nLet us help you choose the right funds!"
  },
  homeloan: {
    keywords: ['home loan', 'house loan', 'property loan', 'emi', 'home loan emi'],
    response: "🏠 Planning to buy your dream home? We offer:\n• Competitive interest rates\n• Flexible tenure up to 30 years\n• Quick processing\n• Low EMI options\n\nUse our Home Loan EMI Calculator to plan your budget!"
  },
  tax: {
    keywords: ['tax', 'saving', '80c', 'tax planning', 'tax saving', 'eltss'],
    response: "📝 Tax Planning helps you save money legally. Options under Section 80C:\n• ELSS Mutual Funds\n• PPF\n• NPS\n• Life Insurance Premium\n• Home Loan Principal\n\nLet us help optimize your tax savings!"
  },
  contact: {
    keywords: ['contact', 'call', 'whatsapp', 'reach', 'consultation', 'advisor', 'expert'],
    response: "📞 We're here to help! Connect with us:\n• Call: 9726344477, 9726766777\n• WhatsApp: 9726344477\n• Email: Wisdom2secure@gmail.com\n• Visit: E-44, Vasant Vihar Society, GIDC -Vadsar Road, Vadodara-390010\n\nWe typically respond within 2 hours!"
  },
  calculators: {
    keywords: ['calculator', 'calculate', 'compute', 'financial calculator'],
    response: "🧮 We have several calculators to help you plan:\n• SIP Calculator\n• Lumpsum Calculator\n• SWP Calculator\n• Retirement Planner\n• Child Education Planner\n• Marriage Planner\n• Home Loan EMI\n\nVisit our Calculators page to use them for free!"
  },
  default: "Thank you for your message! For personalized assistance, please call us at 9726344477 or WhatsApp us. You can also visit our Calculators page for financial planning tools. Is there anything specific I can help you with regarding investments, insurance, or loans?"
};

export const getChatbotResponse = (userMessage) => {
  const message = userMessage.toLowerCase();

  // Check for keywords and return appropriate response
  for (const [category, data] of Object.entries(responses)) {
    if (category !== 'default' && data.keywords.some(keyword => message.includes(keyword))) {
      return data.response;
    }
  }

  return responses.default;
};